var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingParentSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 412,
    viewBox: "0 0 502 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.285 256.533C232.445 256.533 128.767 256.533 128.767 256.533C58.2031 256.533 1 199.33 1 128.767C1 58.2031 58.2031 1 128.767 1H373.233C443.797 1 501 58.2031 501 128.767C501 179.065 471.935 222.576 429.683 243.418",
    stroke: "#D6DCFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.76 203.842C283.229 139.898 352.655 164.214 352.655 164.214C352.655 164.214 405.727 179.565 421.279 219.849C436.831 260.133 419.206 308.367 414.25 333.574C409.294 358.78 352.655 367.452 319.97 341.086C287.284 314.719 291.145 311.595 291.145 311.595C291.145 311.595 291.941 304.832 296.1 301.302",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.76 203.842C283.229 139.898 352.655 164.214 352.655 164.214C352.655 164.214 405.727 179.565 421.279 219.849C436.831 260.133 419.206 308.367 414.25 333.574C409.294 358.78 352.655 367.452 319.97 341.086C287.284 314.719 291.145 311.595 291.145 311.595C291.145 311.595 291.941 304.832 296.1 301.302",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.985 139.198L164.392 145.956C164.392 145.956 160.431 143.147 157.581 145.636C154.731 148.125 157.008 154.578 160.987 156.531C164.965 158.484 167.332 158.484 167.332 158.484C167.332 158.484 171.884 173.885 175.981 179.073C180.078 184.262 191.066 189.273 191.066 189.273H213.909V173.241C213.909 173.241 218.698 163.448 218.698 156.486C222.5 155.355 229.368 151.266 228.231 142.745C225.224 136.673 219.427 142.745 219.427 142.745L220.204 119.729L195.591 109.307L162.985 139.198Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162 138.092L161.831 137.107L160.845 137.276L161.014 138.262L162 138.092ZM171.852 173.486L172.727 173.002L171.852 173.486ZM163.971 137.753L164.957 137.584L164.787 136.598L163.802 136.768L163.971 137.753ZM173.602 172.518L172.727 173.002L173.602 172.518ZM182.782 183.452L183.592 184.039L184.179 183.23L183.37 182.643L182.782 183.452ZM181.608 185.071L181.021 185.881L181.83 186.468L182.418 185.658L181.608 185.071ZM217.164 168.767L218.086 169.154L217.164 168.767ZM219.658 156.544L220.652 156.659L219.658 156.544ZM211.109 179.362L210.496 180.152L211.285 180.766L211.899 179.976L211.109 179.362ZM209.529 178.136L208.74 177.522L208.126 178.312L208.916 178.925L209.529 178.136ZM215.32 167.993L214.398 167.606L215.32 167.993ZM217.672 156.313L216.678 156.198L217.672 156.313ZM219.204 134.184L219.244 133.185L218.244 133.145L218.204 134.144L219.204 134.184ZM221.202 134.264L222.201 134.304L222.241 133.305L221.242 133.265L221.202 134.264ZM161.014 138.262C163.921 155.169 167.21 167.161 170.977 173.97L172.727 173.002C169.138 166.516 165.891 154.823 162.986 137.923L161.014 138.262ZM163.802 136.768L161.831 137.107L162.169 139.078L164.141 138.739L163.802 136.768ZM174.477 172.034C171.067 165.87 167.861 154.477 164.957 137.584L162.986 137.923C165.891 154.823 169.138 166.516 172.727 173.002L174.477 172.034ZM183.37 182.643C179.92 180.141 176.906 176.426 174.477 172.034L172.727 173.002C175.255 177.572 178.445 181.542 182.195 184.262L183.37 182.643ZM182.418 185.658L183.592 184.039L181.973 182.865L180.799 184.484L182.418 185.658ZM170.977 173.97C173.603 178.718 176.97 182.942 181.021 185.881L182.195 184.262C178.445 181.542 175.255 177.572 172.727 173.002L170.977 173.97ZM218.086 169.154C219.161 166.593 219.991 162.358 220.652 156.659L218.665 156.428C218.005 162.121 217.197 166.105 216.242 168.38L218.086 169.154ZM211.899 179.976C214.734 176.326 216.755 172.324 218.086 169.154L216.242 168.38C214.953 171.45 213.012 175.282 210.319 178.749L211.899 179.976ZM208.916 178.925L210.496 180.152L211.722 178.573L210.143 177.346L208.916 178.925ZM214.398 167.606C213.151 170.577 211.29 174.239 208.74 177.522L210.319 178.749C213.012 175.282 214.953 171.45 216.242 168.38L214.398 167.606ZM216.678 156.198C216.019 161.885 215.233 165.617 214.398 167.606L216.242 168.38C217.197 166.105 218.005 162.121 218.665 156.428L216.678 156.198ZM218.204 134.144C217.84 143.23 217.33 150.576 216.678 156.198L218.665 156.428C219.325 150.736 219.838 143.334 220.203 134.224L218.204 134.144ZM221.242 133.265L219.244 133.185L219.164 135.183L221.162 135.263L221.242 133.265ZM220.652 156.659C221.32 150.896 221.835 143.439 222.201 134.304L220.203 134.224C219.838 143.334 219.325 150.736 218.665 156.428L220.652 156.659Z",
    fill: "#1D70D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.582 112.199C216.565 112.199 227.09 101.719 227.09 88.7925C227.09 75.8656 216.565 65.3864 203.582 65.3864C190.599 65.3864 180.074 75.8656 180.074 88.7925C180.074 101.719 190.599 112.199 203.582 112.199Z",
    fill: "#FF9B6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.756 142.677C219.756 142.677 223.794 137.682 227.115 141.118C230.436 144.554 225.956 156.531 218.754 156.531",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.711 143.551C163.711 143.551 191.652 135.902 199.364 118.103C208.904 131.711 220.202 136.66 220.202 136.66C220.202 136.66 223.036 126.743 221.44 115.472C219.844 104.2 211.617 96.3716 201.948 94.8018C191.832 86.8875 175.971 91.4481 165.784 108.951C155.596 126.454 163.711 143.551 163.711 143.551Z",
    fill: "#FF9B6D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.127 146.033C164.127 146.033 160.083 142.538 156.49 146.033C152.897 149.528 161.685 159.378 167.33 158.419",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.473 151.385L159.418 149.371",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.426 148.464L223.375 145.956",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.067 286.462C287.067 286.462 290.149 305.88 282.594 319.39C275.039 332.901 220.743 358.625 203.584 362.143C186.425 365.661 155.652 357.699 155.652 354.191C155.652 350.684 183.776 351.572 186.425 348.868C176.34 337.885 175.549 331.04 183.77 334.919C191.991 338.797 194.748 343.724 203.584 343.724L259.295 313.568L256.642 289.869L287.067 286.462Z",
    fill: "#FAFAFA",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.926 132.083C159.926 132.083 181.491 117.848 189.073 103.839",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.905 198.606C213.905 198.606 252.612 211.96 264.232 221.183C275.852 230.406 291.017 288.705 291.017 288.705L254.194 291.184L249.609 273.698V305.29L256.355 338.798H150.443L153.082 297.513L144.319 288.705L133.647 317.15L100.006 303.68C100.006 303.68 113.712 244.614 128.194 230.345C142.676 216.076 177.555 201.023 177.555 201.023C177.555 201.023 175.276 210.788 180.074 217.063C188.47 228.042 211.899 233.603 217.646 214.605C220.2 206.16 213.905 198.606 213.905 198.606Z",
    fill: "#FFDC84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.605 138.77C161.605 138.77 185.21 126.131 193.509 113.692",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.906 173.271C213.906 173.271 213.906 192.859 213.906 198.606C213.906 204.353 217.647 209.465 217.647 209.465",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.471 135.605C188.471 135.605 190.308 141.06 190.308 148.133C190.308 155.207 188.471 163.809 189.389 165.293C190.308 166.777 195.588 165.293 195.588 165.293",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.557 94.5917C177.557 94.5917 196.705 86.5935 203.583 93.3117C215.505 95.3455 220.202 108.086 220.202 108.086",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.941 155.667C213.433 155.667 218.695 150.428 218.695 143.964C218.695 137.501 213.433 132.261 206.941 132.261C200.45 132.261 195.188 137.501 195.188 143.964C195.188 150.428 200.45 155.667 206.941 155.667Z",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.719 157.339C183.21 157.339 188.473 152.099 188.473 145.636C188.473 139.173 183.21 133.933 176.719 133.933C170.227 133.933 164.965 139.173 164.965 145.636C164.965 152.099 170.227 157.339 176.719 157.339Z",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.766 141.666C187.766 141.666 191.118 137.086 195.189 141.006",
    stroke: "#D6DCFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 252.496C146.604 252.496 138.682 271.416 141.322 280.061C143.963 288.705 153.083 297.513 153.083 297.513L150.444 338.797",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.15 142.745C202.15 142.745 206.695 138.204 211.239 141.821",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M188.224 173.557C188.224 173.557 192.053 175.585 198.236 172.143",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.61 143.669C180.61 143.669 175.952 140.217 171.69 144.741",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7847 217.114C90.7847 217.114 94.924 292.79 97.0535 305.156C104.369 347.64 130.194 337.74 133.301 317.953C136.409 298.167 111.716 213.739 111.716 213.739C111.716 213.739 116.322 200.466 117.123 190.313C117.633 183.832 118.181 178.164 118.51 174.914C118.671 173.318 117.494 171.898 115.896 171.766C114.618 171.661 113.428 172.421 112.986 173.624L108.141 186.812L104.649 158.385C104.489 157.086 103.386 156.11 102.078 156.11C100.626 156.11 99.4578 157.303 99.4882 158.755L99.9755 182.047L95.8001 156.591C95.5626 155.143 94.2208 154.144 92.766 154.332C91.3475 154.515 90.3126 155.765 90.3974 157.192L91.9259 182.922L87.045 160.404C86.7094 158.855 85.2264 157.835 83.6602 158.076C82.0059 158.331 80.8806 159.891 81.1612 161.541L85.459 186.812L79.6079 172.962C78.9483 171.401 77.1857 170.625 75.5886 171.192C73.938 171.779 73.0626 173.577 73.6218 175.237C75.7533 181.565 80.6144 196.174 81.8599 201.44C83.4687 208.243 90.7847 217.114 90.7847 217.114Z",
    fill: "#FAFAFA",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.935 184.089C108.935 184.089 107.159 189.69 104.435 193.487C101.711 197.283 93.3149 198.246 91.082 204.613",
    stroke: "#1D70D3",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0293 188.1C85.0293 186.861 91.0813 180.489 103.482 182.493",
    stroke: "#1D70D3",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.109 315.936C256.63 318.679 270.72 321.151 275.415 342.351C280.111 363.55 285.646 386.448 285.646 386.448C285.646 386.448 292.493 392.384 295.48 394.06C300.586 396.925 304.894 397.22 304.523 399.063C303.641 403.445 284.925 400.142 276.745 400.142C268.564 400.142 269.309 387.335 269.309 387.335C269.309 387.335 259.752 366.174 252.883 343.706L245.491 343.511C245.491 343.511 237.96 327.272 249.109 315.936Z",
    fill: "#FAFAFA",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.37 344.051H247.169C238.884 330.053 248.837 316.008 250.659 316.008C252.481 316.008 228.37 309.19 228.37 309.19L223.734 300.53C223.734 300.53 170.129 304.06 168.571 304.06C167.012 304.06 162.252 349.687 179.663 353.565C197.074 357.444 203.315 349.25 203.315 349.25L228.37 344.051Z",
    fill: "#FF9B6D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.615 317.15L207.113 321.631",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.561 323.79C222.082 326.586 225.832 330.49 229.84 347.122C233.847 363.755 238.939 387.998 238.939 387.998C238.939 387.998 244.163 393.279 247.909 403.026C250.512 409.799 244.939 411.567 242.454 405.595C242.988 411.548 237.7 410.184 235.204 410.184C227.024 410.184 223.733 392.988 223.733 392.988C223.733 392.988 214.177 371.412 207.308 348.504L200.008 349.962C200.008 349.962 191.207 331.069 205.183 321.897C208.922 322.224 212.048 322.855 214.561 323.79Z",
    fill: "#FAFAFA",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274.252 387.467C274.252 387.467 274.336 392.712 278.609 392.712",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.685 409.689C238.99 408.821 238.006 405.611 238.006 405.611",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M235.311 409.689L234.271 405.857",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.288 408.955V405.611",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.426 240.88C186.426 240.88 175.779 242.79 172.224 244.611C165.539 248.036 162.375 253.5 160.922 260.274C159.783 265.588 159.935 273.702 164.393 279.551C165.219 289.393 166.788 315.936 166.788 315.936L228.37 309.19C228.37 309.19 223.443 277.89 221.402 267.299L238.204 268.702L239.693 250.862C239.693 250.862 225.54 246.508 216.9 243.083C212.58 241.371 186.426 240.88 186.426 240.88Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.402 267.299L223.707 254.215",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.453 252.834L249.003 254.168L269.983 214.607C269.983 214.607 269.983 209.308 269.983 204.793C269.983 201.69 270.722 197.879 271.184 195.799C271.385 194.893 272.195 194.265 273.123 194.265C274.165 194.265 275.039 195.05 275.151 196.085L276.175 205.585L283.05 191.577C283.535 190.587 284.741 190.191 285.719 190.7C286.55 191.133 286.96 192.093 286.696 192.993L283.935 202.427L289.829 192.999C290.386 192.108 291.515 191.764 292.475 192.192C293.528 192.662 294.008 193.892 293.55 194.952L288.958 205.585L296.173 198.37C296.896 197.648 298.057 197.618 298.816 198.301C299.574 198.984 299.666 200.14 299.026 200.933L290.801 211.137L298.753 206.423C299.546 205.953 300.569 206.185 301.082 206.951C301.559 207.662 301.447 208.612 300.812 209.186C297.802 211.906 289.285 219.44 283.935 222.542C279.336 232.049 265.85 270.132 257.867 272.16C249.883 274.189 235.746 270.374 235.746 270.374L240.453 252.834Z",
    fill: "#FAFAFA",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M194.047 244.611C194.047 244.611 198.016 256.287 205.506 255.228C212.997 254.168 212.049 246.233 212.049 246.233",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.609 209.465L186.423 212.868",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.789 240.781C179.857 234.132 180.17 225.701 179.463 220.675C175.046 219.933 172.059 212.403 174.433 206.676C176.017 202.857 178.32 202.169 181.343 204.611C180.801 193.436 186.992 187.848 199.917 187.848C219.305 187.848 224.131 198.972 221.718 213.503C219.305 228.034 222.995 226.7 221.718 235.436C220.44 244.172 208.047 252.292 193.835 245.526",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M186.789 240.781C179.857 234.132 180.17 225.701 179.463 220.675C175.046 219.933 172.059 212.403 174.433 206.676C176.017 202.857 178.32 202.169 181.343 204.611C180.801 193.436 186.992 187.848 199.917 187.848C219.305 187.848 224.131 198.972 221.718 213.503V213.503C219.305 228.034 222.995 226.7 221.718 235.436C220.44 244.172 208.047 252.292 193.835 245.526",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.53 207.427C183.94 210.76 183.229 220.333 185.214 220.857C187.199 221.381 186.067 205.846 187.382 205.015C188.698 204.184 192.959 202.072 194.695 196.893C199.901 201.687 207.133 207.005 223.592 205.015C223.592 205.015 224.82 193.753 215.376 185.022C205.931 176.29 189.818 177.631 182.574 186.044C170.886 186.963 174.023 210.408 174.023 210.408C174.023 210.408 177.856 203.905 181.53 207.427Z",
    fill: "#1D70D3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M220.41 206.101C220.41 206.101 212.226 202.838 208.883 195.41",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.908 206.513C209.908 206.513 202.184 202.282 199.775 194.503",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M210.764 220.87C210.764 220.87 211.409 225.761 213.271 227.354C215.132 228.947 211.957 230.509 211.957 230.509",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.16 215.048C215.16 215.048 218.462 213.073 220.941 215.018",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M196.865 215.377C196.865 215.377 200.36 213.103 203.313 215.377",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M179.664 214.183L176.547 211.688",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.958 235.56C213.958 235.56 208.335 235.807 205.443 234.602C205.443 234.602 206.494 238.958 209.189 238.958C211.885 238.958 213.958 235.56 213.958 235.56Z",
    fill: "#FF9B6D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.759 311.151C265.06 311.151 277.464 298.8 277.464 283.565C277.464 268.33 265.06 255.979 249.759 255.979C234.457 255.979 222.053 268.33 222.053 283.565C222.053 298.8 234.457 311.151 249.759 311.151Z",
    fill: "#0ACC94"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.595 278.393L194.648 285.241L238.125 305.75C238.125 305.75 243.815 302.847 247.492 301.838C249.806 301.202 252.081 300.405 253.449 299.901C254.197 299.625 255.041 299.923 255.437 300.615C255.836 301.314 255.654 302.201 255.011 302.686L251.365 305.439H268.191C268.191 305.439 258.307 317.15 249.863 317.15C241.42 317.15 236.473 315.284 236.473 315.284C236.473 315.284 195.758 307.76 186.761 301.838C177.765 295.915 173.361 289.021 173.361 289.021",
    fill: "#FAFAFA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M191.595 278.393L194.648 285.241L238.125 305.75C238.125 305.75 243.815 302.847 247.492 301.838C249.806 301.202 252.081 300.405 253.449 299.901C254.197 299.625 255.041 299.923 255.437 300.615V300.615C255.836 301.314 255.654 302.201 255.011 302.686L251.365 305.439H268.191C268.191 305.439 258.307 317.15 249.863 317.15C241.42 317.15 236.473 315.284 236.473 315.284C236.473 315.284 195.758 307.76 186.761 301.838C177.765 295.915 173.361 289.021 173.361 289.021",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M176.544 249.964C176.544 249.964 183.255 257.602 189.44 270.052L193.318 277.426L173.357 289.021L166.785 280.48",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.111 354.812C207.111 354.812 187.219 338.797 182.366 338.797C177.514 338.797 187.613 349.25 187.613 349.25C187.613 349.25 157.167 352.861 164.007 354.812C170.846 356.762 177.34 355.701 177.34 355.701",
    fill: "#FAFAFA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M207.111 354.812C207.111 354.812 187.219 338.797 182.366 338.797C177.514 338.797 187.613 349.25 187.613 349.25C187.613 349.25 157.167 352.861 164.007 354.812C170.846 356.762 177.34 355.701 177.34 355.701",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M276.176 205.585L280.561 214.183",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.25 151.833L336.878 121.459C336.878 121.459 345.01 120.756 345.207 109.486C345.403 98.2164 332.199 102.614 332.213 101.811C332.227 101.009 314.11 78.7589 314.11 78.7589L274.387 85.4888C274.387 85.4888 273.037 134.495 281.82 141.972C287.162 148.478 299.87 146.569 299.87 146.569C299.87 146.569 303.818 150.447 304.825 151.107C305.833 151.766 338.25 151.833 338.25 151.833Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M275.25 85.004C275.25 85.004 272.74 139.523 286.085 145.037C292.594 147.727 302.22 146.729 314.963 142.042",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.054 135.819L295.86 132.775C295.86 132.775 295.663 136.596 292.543 137.936C289.423 139.276 287.054 135.819 287.054 135.819Z",
    fill: "#FF9B6D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M294.886 104.132C294.886 104.132 299.803 100.008 305.705 101.987",
    stroke: "#1D70D3",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M274.454 106.388C274.454 106.388 276.777 103.259 279.785 105.022",
    stroke: "#1D70D3",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M294.812 112.188C294.812 112.188 299.728 108.064 305.631 110.043",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M274.379 114.444C274.379 114.444 276.703 111.315 279.711 113.078",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M336.239 112.87L340.873 108.357",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M283.153 106.671C283.153 106.671 285.073 111.736 284.177 115.779C283.281 119.822 280.442 127.739 281.398 129.351C282.354 130.963 288.124 128.242 288.124 128.242",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.499 84.1792C266.499 84.1792 253.517 96.3988 276.917 97.7691C300.317 99.1395 312.545 90.1947 312.545 90.1947C312.545 90.1947 318.349 102.463 324.555 104.888C330.761 107.314 329.267 118.65 333.672 118.187C338.076 117.724 335.811 104.754 335.811 104.754C335.811 104.754 339.903 102.191 343.06 102.943C346.216 103.695 348.437 71.4244 343.204 67.0978C337.97 62.7711 331.543 64.1456 331.543 64.1456C331.543 64.1456 328.218 53.1343 319.084 52.838C309.95 52.5418 262.272 62.779 268.347 73.0775C258.537 74.1131 266.499 84.1792 266.499 84.1792Z",
    fill: "#1D70D3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M339.416 152.549L337.389 120.473C337.389 120.473 344.606 120.258 345.538 109.594C346.469 98.9309 335.603 103.482 335.603 103.482",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.996 146.875L344.184 148.276V158.521L355.125 163.879L313.802 232.388L289.732 161.531L299.996 158.521V146.875Z",
    fill: "#FFDC84"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M305.83 147.881V158.948",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M313.877 147.881V158.948",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M320.92 147.881V158.948",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M327.961 147.881V158.948",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M337.018 147.881V158.948",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.539 283.357C296.155 279.983 288.535 258.725 282.394 254.556C276.253 250.387 264.841 254.185 255.809 256.033C246.777 257.881 251.85 263.895 251.85 263.895C251.85 263.895 248.398 268.909 253.005 271.109C251.299 272.986 251.972 277.487 259.981 276.612C257.594 279.982 260.909 281.366 265.134 281.366C269.359 281.366 275.441 281.366 275.441 281.366C275.441 281.366 275.288 283.563 281.915 288.987C288.542 294.412 297.759 305.098 297.759 305.098C297.759 305.098 307.656 306.024 310.64 294.298",
    fill: "#FAFAFA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M301.539 283.357C296.155 279.983 288.535 258.725 282.394 254.556C276.253 250.387 264.841 254.185 255.809 256.033C246.777 257.881 251.85 263.895 251.85 263.895C251.85 263.895 248.398 268.909 253.005 271.109C251.299 272.986 251.972 277.487 259.981 276.612C257.594 279.982 260.909 281.366 265.134 281.366C269.359 281.366 275.441 281.366 275.441 281.366C275.441 281.366 275.288 283.563 281.915 288.987C288.542 294.412 297.759 305.098 297.759 305.098C297.759 305.098 307.656 306.024 310.64 294.298",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M251.85 263.895L268.111 261.314C268.111 261.314 277.272 257.392 279.598 260.643",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M252.924 271.54L270.259 268.592C270.259 268.592 278.014 266.119 280.672 268.592",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M259.98 276.612L273.889 274.325C273.889 274.325 278.949 273.603 280.671 275.468",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M308.848 288.477C308.848 288.477 325.348 285.377 343.589 294.977C361.829 304.577 385.075 305.717 394.361 314.883",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M368.203 303.817L382.288 230.376",
    stroke: "#1D70D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M313.878 231.382L308.848 269.612",
    stroke: "#D6DCFF",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingParentSchool);
export default __webpack_public_path__ + "static/media/OnboardingParentSchool.062dbfccf674cbc8a029d076da6c219d.svg";
export { ForwardRef as ReactComponent };